import { WprBaseViewModeInfo } from '../../../wpr-framework/mode/WprBaseViewMode';
import { WprDI_Control } from '../../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../../wpr-framework/view/control/WprControlInfo';
import { ConfirmComponentView } from '../ConfirmComponentView';

/**
 * 申込内容確認モード
 */
export class ConfirmMode extends WprBaseViewModeInfo<ConfirmComponentView> {
	// DI情報  ------------------------------------------------------------------
	@WprDI_Control
	private m_check: WprControlInfo = null; // チェックボタン
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('ConfirmMode');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * モードリスト取得（この画面モードで使用する全てのモードを定義する）
	 * @param list モードリスト
	 */
	public useModeList(list: string[]): void {
		list.push('チェック済');
		list.push('未チェック');
	}

	/**
	 * フィールド定義を登録処理
	 */
	public onRegisterControl(): void {
		this.addControl('check', { check: true });
		this.addControl('toNext', { enabled: [{ mode: '未チェック', value: false }, { mode: 'other', value: true },], });
	}

	/**
	 * 画面の状態をチェックしてモードを変更する
	 * @param curMode 現在のモード
	 * @return 新しいモード（変更ない場合は現在のモード）
	 */
	public onCheckMode(curMode: string): string {
		if (this.m_check.value !== true) {
			return '未チェック';
		}
		else {
			return 'チェック済';
		}
	}
	// --------------------------------------------------------------------------
}
